// extracted by mini-css-extract-plugin
module.exports = {"container":"_82dGd","left":"_3ToPR","right":"E4kwg","moreButton":"_1wWwg","image":"_3ODfF","title":"kVG_a","collapsedPart":"_17-FT"};